import {
  OfqualRoles,
  CCEARoles,
  AoRoles,
  UserRoleText,
  UserRole,
} from "../services/domain/userRole";
import { UserType } from "../redux/types";

// when creating users, default roles allow users of each type
//  to be given roles that are added automatically
const OFQUAL_DEFAULT_ROLES: UserRole[] = [UserRole.OFQUALStaff];
const CCEA_DEFAULT_ROLES: UserRole[] = [UserRole.CCEAStaff];
const AO_DEFAULT_ROLES: UserRole[] = [UserRole.AO];

const buildLookups = (defaultRoles: UserRole[], allRoles: UserRole[]) => {
  const defaultLookups = defaultRoles.map((role) => ({
    id: role.toString(),
    label: UserRoleText[role],
    isDefault: true,
  }));

  const nonDefaultLookups = allRoles
    .filter((role) => !defaultRoles.includes(role))
    .map((role) => ({
      id: role.toString(),
      label: UserRoleText[role],
      isDefault: false,
    }));

  return [
    // make defaults appear first in the UI
    ...defaultLookups,
    ...nonDefaultLookups,
  ];
};

export const roles = {
  [UserType.Ofqual]: {
    defaultRoles: OFQUAL_DEFAULT_ROLES.map((role) => role.toString()),
    roleLookups: buildLookups(OFQUAL_DEFAULT_ROLES, OfqualRoles),
  },
  [UserType.CCEA]: {
    defaultRoles: CCEA_DEFAULT_ROLES.map((role) => role.toString()),
    roleLookups: buildLookups(CCEA_DEFAULT_ROLES, CCEARoles),
  },
  [UserType.AO]: {
    defaultRoles: AO_DEFAULT_ROLES.map((role) => role.toString()),
    roleLookups: buildLookups(AO_DEFAULT_ROLES, AoRoles),
  },
};
